import styled from "styled-components";
import {
  ACCENT_SECONDARY_LIGHTEST,
  BRAND_DARK,
  GRAY_LIGHT,
  WHITE
} from "@streeteasy/design-system/colors";
import componentSizes from "@streeteasy/design-system/constants/componentSizes";
import ButtonLink from "@streeteasy/design-system/deprecated/actions/button-link";
import TextLink, {
  textLinkTypography
} from "@streeteasy/design-system/deprecated/actions/text-link";
import {
  PrimaryLarge,
  PrimarySmall
} from "@streeteasy/design-system/typography";

import { smallScreen } from "src/shared/constants/screenSizes";

export const AmenitiesSectionContainer = styled.section`
  background-color: ${ACCENT_SECONDARY_LIGHTEST};
  padding: 64px 36px;
  text-align: center;

  @media screen and (max-width: ${smallScreen}px) {
    padding: 48px 0 52px;
  }
`;

export const AmenitiesList = styled.div`
  display: flex;
  justify-content: center;
  padding: 31px 0;

  @media screen and (max-width: ${smallScreen}px) {
    flex-direction: column;
    margin: 0 auto;
    max-width: 420px;
    padding-bottom: 28px;
    padding-top: 36px;
  }
`;

export const AmenityItem = styled.div`
  border: 1px solid ${GRAY_LIGHT};
  margin: 12px;
  text-align: left;

  @media screen and (max-width: ${smallScreen}px) {
    margin: 4px 0 6px;
  }
`;

export const Container = styled.div`
  @media screen and (max-width: ${smallScreen}px) {
    padding: 0 24px;
  }
`;

export const Link = styled(TextLink).attrs({
  color: BRAND_DARK,
  typography: textLinkTypography.CAPS
})`
  border-bottom: 0;
`;

export const SeeListingsButton = styled(ButtonLink).attrs({
  size: componentSizes.LG
})`
  margin: 8px;

  @media screen and (max-width: ${smallScreen}px) {
    margin: 4px auto;
    max-width: 224px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;

  @media screen and (max-width: ${smallScreen}px) {
    flex-direction: column;
  }
`;

export const CheckboxWrapper = styled.div`
  background: ${WHITE};
  padding: 12px 10px;

  label {
    &:hover {
      background: none;
    }
  }

  @media screen and (max-width: ${smallScreen}px) {
    padding-bottom: 11px;
    padding-top: 11px;
  }
`;

export const Title = styled(PrimaryLarge)`
  padding: 0 0 8px;
`;

export const Subtitle = styled(PrimarySmall)`
  padding: 0 0 2px;
`;

export const Img = styled.img`
  display: block;
  max-width: 420px;
  width: 100%;

  @media screen and (max-width: ${smallScreen}px) {
    display: none;
  }
`;

export const MobileImg = styled.img`
  display: none;

  @media screen and (max-width: ${smallScreen}px) {
    display: block;
    margin-top: 29px;
    width: 100%;
  }
`;
